import { Grid } from '@mui/material';
import { Link } from '~/components/Link';
import { ReportImage } from '~/components/ReportImage';
import { SummaryCard } from '~/components/SummaryCard';
import { cleanReportName } from '~/scripts/cleanReportName';

export default function RecommendedSearches() {
  return (
    <Grid container item xs={12} spacing={1} sx={{ p: 3 }}>
      {[
        {
          uuid: 'd513e568-ad32-44b5-b0c8-1b7d3fbe88a6',
          name: 'Shopify Stores',
          description:
            'Search for stores built with Shopify, or any CMS platform',
          href: '/reports/shopify/a69ebdba-03ef-423d-b8f3-2b474b98f8d2',
        },
        {
          uuid: 'a9e5c921-6753-4dd5-bbf1-d3e781a53414',
          name: 'Hubspot CRM users',
          description: 'List websites using Hubspot CRM',
          href: '/reports/hubspot/9dae7232-0157-47dd-983d-14da1da53a27',
        },
        {
          uuid: 'f48d9932-2638-426a-9ca8-d84a6b78fd6e',
          name: 'Intercom Chat Widget',
          description: 'List websites using Intercom for Chat and Support',
          href: '/reports/intercom/0d66ce05-38da-4248-9b8f-7c2a9cca8d69',
        },
        {
          uuid: '7da5a261-bf51-4098-b6d9-1c8e0f813b08',
          name: 'WooCommerce Stores',
          description: 'Search for stores built on the WooCommerce platform',
          href: '/reports/woocommerce/dddc00c4-aed6-4d0f-b86c-38a5829317cc',
        },
        {
          uuid: '26cd9529-de61-4704-9902-6de1a24485a0',
          name: 'Customers at Risk',
          description: 'Mixpanel customers who have also installed competitors',
          href: '/reports/mixpanel-and-heap-analytics-or-amplitude-analytics-or-snowplow-analytics/1c030931-f511-49ca-a71d-56fc9f9f7ec0',
        },
        {
          uuid: '795bae79-af8a-43e9-8f76-c7d62378d388',
          name: 'Category Market Research',
          description: 'Websites with AdTech that include fashion keywords',
          href: '/reports/fashion-and-oracle-moat-or-google-adsense-or-appnexus/214481a8-2a2c-4ab5-9c5f-3df4524cd52b',
        },
        {
          uuid: 'e0da30f9-f622-4c97-93ff-29bdbb135f75',
          name: 'Blogs using Stripe',
          description: 'CMS sites powered by Stripe for payments',
          href: '/reports/stripe-and-weebly-or-drupal-or-wordpress/558b78be-9e5e-422e-83cb-cb2a70eabe50',
        },
        {
          uuid: 'a5e99983-4836-42b0-9869-162d78db7524',
          name: 'Wordpress',
          description: 'Websites using Wordpress',
        },
        {
          uuid: 'ef5f765a-9d26-4f73-88f5-b02c862a9a40',
          name: 'Braintree',
          description: 'Websites using Braintree for payments',
        },
        {
          uuid: '31a297df-b771-4c21-b673-2c57a9a2543b',
          name: 'Facebook Ads',
          description: 'Websites using Facebook Ads',
        },
        {
          uuid: '344ff9ed-80cd-4375-967e-453a74d6f0b5',
          name: 'Adyen',
          description: 'Websites using Adyen for payments',
        },
        {
          uuid: '862eed5d-4b4d-43d2-9881-5cd62dd2dcf0',
          name: 'Magento',
          description: 'Websites using Magento for ecommerce',
        },
        {
          uuid: 'c54c39a2-a979-4ef6-8ae9-3c1770fac7ee',
          name: 'Braze',
          description: 'Websites using Braze for customer engagement',
        },
      ].map(({ uuid, name, description, href }) => {
        return (
          <Grid item xs={12} key={uuid}>
            <Link
              underline={'none'}
              href={
                href || `/technology-reports/${cleanReportName(name)}/${uuid}`
              }>
              <SummaryCard
                icon={<ReportImage uuid={uuid} height={25} width={25} />}
                title={name}
                subtitle={description}
              />
            </Link>
          </Grid>
        );
      })}
    </Grid>
  );
}
